/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompanyDto } from './companyDto';
import { ClientLoyaltyProgramDto } from './clientLoyaltyProgramDto';


export interface CouponDto { 
    id?: number;
    uuid?: string;
    name?: string;
    description?: string;
    duration?: number;
    image?: string;
    price?: number;
    enabled?: boolean;
    visible?: boolean;
    unlimitedDuration?: boolean;
    company?: CompanyDto;
    created?: string;
    loyaltyProgram?: ClientLoyaltyProgramDto;
    externalCodeEnabled?: boolean;
    externalChannelLabel?: string;
    externalChannelUrl?: string;
    codesTotal?: number;
    codesAvailable?: number;
    codesDepleted?: boolean;
    lowStockThreshold?: number;
}

